import React from 'react';
import AppAdminColumn from './AppAdminColumn.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function AppAdmin() 
{
    const { app_user } = useCTAL();

    return ( <> <AppAdminColumn /> </> );
}